import { Accordion, Typography, AccordionSummary, Stack } from '@mui/material';
import { netsuiteInvoiceActivitySelectors } from '@vy/app-selectors';
import { VyIcon } from '@vy/ui-design-system';
import { FC } from 'react';
import { useToggle } from '../../../../../../../../../../../hooks/use-toggle';
import { ItemOf, Optional } from '@vy/utils';
import { NetSuiteIntegrationStatusAccordionDetails } from './integration-status-accordion-components/NetSuiteIntegrationStatusAccordionDetails';
import { useIntegrationStatus } from '../../../../../../../../../../../hooks/use-integration-status';
import { GetExportedIntegrationsResponse, GetLightInvoicesResponse } from '@vy/api-definition';

type NetSuiteIntegrationStatusAccordionProps = {
  invoice: ItemOf<GetLightInvoicesResponse['invoices']>;
  netSuiteIntegration: Optional<ItemOf<GetExportedIntegrationsResponse>>;
};

export const NetSuiteIntegrationStatusAccordion: FC<NetSuiteIntegrationStatusAccordionProps> = ({
  invoice,
  netSuiteIntegration,
}) => {
  const [expanded, toggleExpanded] = useToggle(true);
  const { isSynced } = useIntegrationStatus(netSuiteIntegration);

  return (
    <Accordion
      data-vy={netsuiteInvoiceActivitySelectors.integrationStatusAccordion}
      expanded={expanded}
      onChange={() => toggleExpanded()}
      sx={{ p: 0 }}
    >
      <AccordionSummary
        expandIcon={
          <VyIcon
            icon="ArrowDown"
            style={{
              color: '#323232',
            }}
          />
        }
        sx={{ p: 0, height: '34px', alignItems: 'center' }}
      >
        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            gap: 1
          }}>
          <VyIcon icon="Synchronize" />
          <Typography
            sx={{
              fontSize: 16,
              fontWeight: 600,
              lineHeight: "24px"
            }}>
            Integration status
          </Typography>

          {isSynced && (
            <div
              data-vy={netsuiteInvoiceActivitySelectors.syncStatusBadge}
              style={{
                width: '8px',
                height: '8px',
                backgroundColor: '#65CF7E',
                borderRadius: '50%',
              }}
            />
          )}
        </Stack>
      </AccordionSummary>
      <NetSuiteIntegrationStatusAccordionDetails
        netSuiteIntegration={netSuiteIntegration}
        invoice={invoice}
      />
    </Accordion>
  );
};
